var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangenotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.975,
    height: 29.986,
    viewBox: "0 0 23.975 29.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-notifications",
    "data-name": "Icon ionic-ios-notifications",
    transform: "translate(-6.761 -3.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11991",
    "data-name": "Path 11991",
    d: "M18.216,32.308c2.331,0,3.6-1.649,3.6-3.972H14.6C14.6,30.659,15.878,32.308,18.216,32.308Z",
    transform: "translate(0.517 1.608)",
    fill: "#ec6321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11992",
    "data-name": "Path 11992",
    d: "M30.432,26.137c-1.154-1.521-3.425-2.413-3.425-9.226,0-6.992-3.088-9.8-5.966-10.477-.27-.067-.465-.157-.465-.442V5.774a1.829,1.829,0,1,0-3.657,0v.217c0,.277-.195.375-.465.442-2.885.682-5.966,3.485-5.966,10.477,0,6.812-2.271,7.7-3.425,9.226A1.488,1.488,0,0,0,8.256,28.52H29.248A1.488,1.488,0,0,0,30.432,26.137Z",
    fill: "#ec6321"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangenotifications);
export default __webpack_public_path__ + "static/media/orangenotifications.426b1331e6d3ba4157a442efc5d71934.svg";
export { ForwardRef as ReactComponent };